/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsAccessibilityWidgetViewProps } from '../../../modules/hosports-accessibility-widget/./hosports-accessibility-widget';
import AccessibilityWidget from './../../../baseComponents/accessibility-widget/./accessibility-widget';

export default (props: IHosportsAccessibilityWidgetViewProps) => {
    return (
        <AccessibilityWidget />
    );
};
